import { z } from 'zod'
import type { FirestoreDataConverter as AdminFirestoreDataConverter } from 'firebase-admin/firestore'
import type { FirestoreDataConverter } from 'firebase/firestore'

export const Partner = z.object({
  name: z.string().regex(/^[a-z_]+$/),
  friendly_name: z.string(),
})
export const UserPartnerLink = z.object({
  user_id: z.string(),
  email: z.string(),
  partner: z.string(),
})

export type PartnerLink = z.infer<typeof UserPartnerLink>

export const quotaFromPartners = (partnerLinks: PartnerLink[]): number => {
  if (!partnerLinks || partnerLinks.length === 0) {
    return 0
  }
  // Each partner link gives 10GB of storage
  return partnerLinks.length * 10_000_000_000
}

//No conversion of dates is needed here, so we can use the same converter for both Firestore and Admin SDK
export const partnerLinkConverter: FirestoreDataConverter<
  PartnerLink,
  PartnerLink
> = {
  toFirestore: (partnerLink: z.infer<typeof UserPartnerLink>) => {
    return UserPartnerLink.parse(partnerLink)
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    const returnData = UserPartnerLink.parse({ ...data, id: snapshot.id })
    return returnData
  },
}

export const adminPartnerLinkConverter: AdminFirestoreDataConverter<
  PartnerLink,
  PartnerLink
> = {
  toFirestore: (partnerLink: z.infer<typeof UserPartnerLink>) => {
    return UserPartnerLink.parse(partnerLink)
  },
  fromFirestore: (snapshot) => {
    const data = snapshot.data()
    const returnData = UserPartnerLink.parse({ ...data, id: snapshot.id })
    return returnData
  },
}
